import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { IChatThreadPinned } from '../_interfaces';

@Injectable()
export class ChatPinnedService {
  constructor(private http: HttpService) {
  }

  get(): Observable<IChatThreadPinned[]> {
    return this.http.get<IChatThreadPinned[]>('/api/v2/pro/chats/pins');
  }

  post(params: IChatThreadPinned): Observable<IChatThreadPinned> {
    return this.http.post<IChatThreadPinned>('/api/v2/pro/chats/pins', params);
  }

  delete(uuid: string) {
    return this.http.delete('/api/v2/pro/chats/pins/' + uuid);
  }
}
